<template>
<div class="home-out">
  <div class="home-cont">
    <div class="cards">
      <div class="card" @click="go('/red-blue')">
        <div class="card-icon red-blue">
          <span class="dot blue"></span>
          <span class="dot red"></span>
        </div>
        <div class="card-name">红蓝对抗</div>
        <div class="card-desc">双人对战棋盘</div>
      </div>
      <div class="card" @click="go('/schulte')">
        <div class="card-icon schulte">
          <div class="mini-grid">
            <span v-for="n in 9" :key="n"></span>
          </div>
        </div>
        <div class="card-name">舒尔特方格</div>
        <div class="card-desc">5×5 / 7×7 / 圆形变体</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'home',
  methods: {
    go (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.home-out{
  height: 100%;
  overflow-y: auto;
}
.home-cont{
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  box-sizing: border-box;
}
.cards{
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
}
.card{
  width: 240px;
  padding: 30px 20px;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  transition: transform 0.15s, box-shadow 0.15s;
  &:hover{
    transform: translateY(-4px);
    box-shadow: 0 6px 16px rgba(0,0,0,0.12);
  }
}
.card-icon{
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
.red-blue{
  .dot{
    display: inline-block;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    margin: 0 6px;
    &.blue{
      background-color: #2196f3;
    }
    &.red{
      background-color: #ff5252;
    }
  }
}
.schulte{
  .mini-grid{
    display: grid;
    grid-template-columns: repeat(3, 18px);
    grid-template-rows: repeat(3, 18px);
    gap: 2px;
    span{
      background-color: #4caf50;
      border-radius: 2px;
    }
  }
}
.card-name{
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 6px;
}
.card-desc{
  font-size: 13px;
  color: #999;
}
</style>
